import {Component, inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {PlayerProfile} from '../../../../../model/player-profile';
import {TranslatePipe} from '@ngx-translate/core';
import {DatePipe} from '@angular/common';
import {Tooltip} from 'primeng/tooltip';
import {Button} from 'primeng/button';
import {RouterLink} from '@angular/router';
import {DateHelper} from '../../../../../../../helper/date.helper';
import {environment} from '../../../../../../../../environments/environment';
import {FrontendNotificationService} from '../../../../../../frontend/service/frontend-notification.service';

@Component({
  selector: 'app-player-profile-payment-status',
  imports: [
    TranslatePipe,
    DatePipe,
    Tooltip,
    Button,
    RouterLink
  ],
  templateUrl: './player-profile-payment-status.component.html',
  styleUrl: './player-profile-payment-status.component.scss'
})
export class PlayerProfilePaymentStatusComponent implements OnInit, OnChanges
{
  private frontendNotificationService = inject(FrontendNotificationService);

  @Input() playerProfile: PlayerProfile;
  @Input() longStatus: boolean;
  @Input() buttonGotoPayment: boolean;

  system = this.frontendNotificationService.system;

  paidToDate: Date;
  paidToDateExpired: Date;

  paymentDateTo: Date;
  showPurchase: boolean;

  ngOnInit(): void
  {
    const diffs = DateHelper.getDaysDiffToNow(new Date(this.playerProfile.account.paymentDateTo));
    this.showPurchase = this.system() !== 'ios' && (!this.playerProfile.account?.paymentDateTo || diffs < 90) && !this.playerProfile.hidePayments;
  }

  public ngOnChanges(changes: SimpleChanges): void
  {
    if (changes.playerProfile)
      this.initPaymentStatus();
  }

  private initPaymentStatus(): void
  {
    console.log('initPaymentStatus()');
    if (this.playerProfile.account?.paymentDateTo)
      this.paymentDateTo = new Date(this.playerProfile.account.paymentDateTo);

    if (this.paymentDateTo)
    {
      if (this.paymentDateTo.getTime() > new Date().getTime())
        this.paidToDate = this.paymentDateTo;
      else this.paidToDateExpired = this.paymentDateTo;
    }
    else
    {
      this.paidToDate = undefined;
      this.paidToDateExpired = undefined;
    }
  }
}
